
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 26 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#D1ED7E","d":"M10.745 16.404c0 1.032.957 1.869 2.137 1.869s2.136-.837 2.136-1.869-.957-1.869-2.136-1.869-2.137.837-2.137 1.869M2.201 15.87c0-1.367.263-2.721.773-3.985a10.4 10.4 0 0 1 2.2-3.378l4.793 4.92c-.312.321-.56.702-.73 1.121s-.256.868-.256 1.322z"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.382","d":"m3.571 12.495 7.25 2.575"}}),_c('circle',{attrs:{"cx":"12.424","cy":"15.861","r":"1.445","stroke":"#234652","stroke-width":"1.382"}}),_c('path',{attrs:{"stroke":"#234652","stroke-width":"1.382","d":"M.752 15.603c0-6.489 5.26-11.749 11.748-11.749s11.748 5.26 11.748 11.749"}})])
          )
        }
      }
    